module.exports = __webpack_public_path__ + "img/Volterres_80X30.f78a9582.png";